import { Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/layout').then((c) => c.Layout),
    children: [
      {
        path: 'checkout',
        loadComponent: () => import('./features/checkout').then((c) => c.Checkout),
        canActivate: [AuthGuard],
      },
      {
        path: 'checkout-subscription',
        loadComponent: () =>
          import('./features/checkout-subscription').then((c) => c.CheckoutSubscription),
        canActivate: [AuthGuard],
      },
      {
        path: 'subscription',
        loadComponent: () =>
          import('./features/create-subscription').then((c) => c.CreateSubscription),
        canActivate: [AuthGuard],
      },
      {
        path: 'choose-plan',
        loadComponent: () => import('./features/choose-plan').then((c) => c.ChoosePlan),
        canActivate: [AuthGuard],
      },
      {
        path: 'select-meal-package',
        loadComponent: () =>
          import('./features/select-meal-package').then((c) => c.SelectMealPackage),
        canActivate: [AuthGuard],
      },
      {
        path: '',
        title: 'Amarilis Healthy Chef',
        loadComponent: () => import('./features/home/home').then((c) => c.Home),
      },
      {
        path: 'legal/privacy-policy',
        title: 'Privacy Policy',
        loadComponent: () => import('./features/legal/privacy-policy').then((c) => c.PrivacyPolicy),
      },
      {
        path: 'secret-garden',
        title: 'El Huerto del Sabor',
        loadComponent: () => import('./features/secret-garden').then((c) => c.SecretGarden),
      },
      {
        path: 'settings',
        title: 'Settings',
        canActivate: [AuthGuard],
        loadComponent: () => import('./features/settings').then((c) => c.Settings),
        children: [
          {
            path: 'profile',
            loadComponent: () => import('./features/update-profile').then((c) => c.UpdateProfile),
          },
          {
            path: 'orders',
            loadComponent: () => import('./features/orders').then((c) => c.Orders),
          },
          {
            path: 'subscriptions',
            loadComponent: () => import('./features/subscriptions').then((c) => c.Subscriptions),
          },

          {
            path: '**',
            redirectTo: 'profile',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'subscriptions/:id',
        loadComponent: () =>
          import('./features/subscription-details').then((c) => c.SubscriptionDetails),
        canActivate: [AuthGuard],
      },
      {
        path: 'subscriptions/:id/update',
        loadComponent: () =>
          import('./features/update-subscription').then((c) => c.UpdateSubscription),
        canActivate: [AuthGuard],
      },
      {
        path: 'orders/:id',
        loadComponent: () => import('./features/order-detail').then((c) => c.OrderDetail),
        canActivate: [AuthGuard],
      },
      {
        path: 'about-us',
        title: 'About Us',
        loadComponent: () => import('./features/about-us/about-us').then((c) => c.AboutUs),
      },
      {
        path: 'healthy-snacks',
        title: 'Healthy Snacks',
        loadComponent: () =>
          import('./features/healthy-snacks/healthy-snacks').then((c) => c.HealthySnacks),
      },
      {
        path: 'services',
        children: [
          {
            path: 'meal-packages',
            redirectTo: '/services/chef-crafted-meals',
            pathMatch: 'full',
          },
          {
            path: 'chef-crafted-meals',
            title: 'Chef-Crafted Meals',
            loadComponent: () =>
              import('./features/meal-packages/meal-packages').then((c) => c.MealPackages),
          },
          {
            path: 'corporate-and-special-events',
            children: [
              {
                path: '',
                redirectTo: '/services/premium-service-for-events',
                pathMatch: 'full',
              },
              {
                path: 'request',
                redirectTo: '/services/premium-service-for-events/request',
                pathMatch: 'full',
              },
            ],
          },
          {
            path: 'premium-service-for-events',
            title: 'Premium Service for Events',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/corporate-events/corporate-events').then(
                    (c) => c.CorporateEvents,
                  ),
              },
              {
                path: 'request',
                loadComponent: () =>
                  import('./features/request-event/request-event').then((c) => c.RequestEvent),
              },
            ],
          },
          {
            path: 'international-culinary-adventure',
            title: 'International Culinary Adventure',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/culinary-adventure/culinary-adventure').then(
                    (c) => c.CulinaryAdventure,
                  ),
              },
              {
                path: 'request',
                loadComponent: () =>
                  import('./features/request-culinary-adventure/request-culinary-adventure').then(
                    (c) => c.RequestCulinaryAdventure,
                  ),
              },
            ],
          },
          {
            path: 'cooking-classes',
            title: 'Cooking Classes',
            children: [
              {
                path: '',
                loadComponent: () =>
                  import('./features/cooking-classes/cooking-classes').then(
                    (c) => c.CookingClasses,
                  ),
              },
              {
                path: 'request',
                loadComponent: () =>
                  import('./features/request-cooking-classes/request-cooking-classes').then(
                    (c) => c.RequestCookingClasses,
                  ),
              },
            ],
          },
          {
            path: 'personal-chef',
            redirectTo: '/services/private-residential-chef',
            pathMatch: 'full',
          },
          {
            path: 'private-residential-chef',
            title: 'Private Residential Chef',
            loadComponent: () =>
              import('./features/request-personal-chef/request-personal-chef').then(
                (c) => c.RequestPersonalChef,
              ),
          },
        ],
      },
    ],
  },
];
